<template>
  <div v-tooltip.bottom="tooltip">
    <shared-step-editor-header-button  :disabled="saveDisabled" @clicked="$emit('save')">{{saving ? 'Saving...' : 'Save'}}  </shared-step-editor-header-button>
  </div>
</template>

<script>
import SharedStepEditorHeaderButton from '../../shared/SharedStepEditorHeaderButton.vue';
import {SocialPostPieceNames} from '../SocialPostPieceNames.js';

export default {
  components: {
    SharedStepEditorHeaderButton,
  }, 
  props: {
    saving: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    pieces: {
      type: Array,
      required: true
    },
    social: String,
    advancedMode: Boolean,  
    linkDangerous: Boolean
  },
  computed: {      
    saveDisabled() {      
      return this.tooltip.length > 0 || this.loading
    },
    tooltip() {
      if(this.imageRequired) {
        return 'The step cannot be saved without an image. Please choose one on the image tab.';
      }      
      if(this.titleRequired) {
        return 'A title is required to save the step.'
      }
      if(this.descriptionRequired) {
        return 'A description is required to save the step.'
      }
      if(this.messageRequired) {
        return 'A message is required to save the step.'
      }
      if(this.captionRequired) {
        return 'A caption is required to save the step.'
      } 
      if(this.advancedMode && this.linkDangerous) {
        return 'Your link is possibly dangerous!'
      }
      return '';
    },
    imageRequired() {
      const piece = this.pieces.find(piece => piece.name === SocialPostPieceNames.ImagePreview);
      return !this.advancedMode && piece ? !piece.content.length  : false;
    },
    titleRequired() {
      const piece = this.pieces.find(piece => piece.name === SocialPostPieceNames.Title);
      return !this.advancedMode && piece ? !piece.content.length  : false;
    },
    descriptionRequired() {
      const piece = this.pieces.find(piece => piece.name === SocialPostPieceNames.Description);
      return !this.advancedMode && piece ? !piece.content.length  : false;
    },
    captionRequired() {
      const piece = this.pieces.find(piece => piece.name === SocialPostPieceNames.Caption);
      return !this.advancedMode && piece ? !piece.content.length  : false;
    },
    messageRequired() {
      const piece = this.pieces.find(piece => piece.name === SocialPostPieceNames.Message);
      return !this.advancedMode && piece ? !piece.content.length  : false;
    }, 
  }, 
};
</script>

<style scoped lang="scss">
</style>
